module.exports = __webpack_public_path__ + "img/pa-shop.a4ce1385.png";